import { SINGLE_SCAN_FAILURE, SINGLE_SCAN_REQUEST, SINGLE_SCAN_SUCCESS } from "../constants/scanConstants";

const initialState = {
  loading: false,
  scans: [],
  error: null
};

const singleScanReducer = (state = initialState, action) => {
  switch (action.type) {
    case SINGLE_SCAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case SINGLE_SCAN_SUCCESS:
      return {
        ...state,
        loading: false,
        scans: action.payload.response || [],
        error: null
      };
    case SINGLE_SCAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default singleScanReducer;